"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropRepeats = exports.createDropRepeats = exports.simpleStream = exports.scan = exports.stream = void 0;
/**
 * Creates a stream.
 *
 * @template T the type of the stream's values.
 *
 * @param initial the stream's initial value.
 *
 * @returns the created stream.
 */
const stream = (initial) => {
    const mapFunctions = [];
    let latestValue = initial;
    const createdStream = function (value) {
        if (arguments.length > 0 && !createdStream.ended) {
            latestValue = value;
            for (const i in mapFunctions) {
                // credit @cmnstmntmn for discovering this bug.
                // Make sure to send the latest value.
                // Otherwise, if f1 triggers another update, f2 will be called with value2 and
                // then value1 (old value).
                mapFunctions[i](latestValue);
            }
        }
        return latestValue;
    };
    createdStream.map = (mapFunction) => {
        const newStream = (0, exports.stream)();
        const mappedFunction = (value) => {
            newStream(mapFunction(value));
        };
        mapFunctions.push(mappedFunction);
        newStream.end = (_value) => {
            const idx = mapFunctions.indexOf(mappedFunction);
            newStream.ended = true;
            mapFunctions.splice(idx, 1);
        };
        if (latestValue !== undefined) {
            newStream(mapFunction(latestValue));
        }
        return newStream;
    };
    createdStream.end = (_value) => {
        createdStream.ended = true;
    };
    return createdStream;
};
exports.stream = stream;
/**
 * Creates a new stream that starts with the initial value and, for each value arriving onto the
 * source stream, emits the result of calling the accumulator function with the latest result and
 * the source stream value.
 */
const scan = (accumulator, initial, sourceStream) => {
    const newStream = (0, exports.stream)(initial);
    let accumulated = initial;
    sourceStream.map((value) => {
        accumulated = accumulator(accumulated, value);
        newStream(accumulated);
    });
    return newStream;
};
exports.scan = scan;
exports.simpleStream = {
    stream: exports.stream,
    scan: exports.scan
};
/**
 * Credit: James Forbes (https://james-forbes.com/)
 *
 * Creates a `dropRepeats` function, which returns new stream that drops repeated values from the
 * source stream.
 *
 * @param stream the stream library, defaults to simpleStream.
 */
const createDropRepeats = (stream = exports.simpleStream) => 
/**
 * @param source the source stream.
 * @param onchange function that receives the current state of the source stream and returns the
 * value for which changes will emit onto the returned stream.
 * @returns a stream that does not emit repeated values.
 */
(source, onchange = (state) => state) => {
    const createStream = typeof stream === 'function' ? stream : stream.stream;
    let prev = undefined;
    const result = createStream();
    source.map((state) => {
        const next = onchange(state);
        if (next !== prev) {
            prev = next;
            result(state);
        }
    });
    return result;
};
exports.createDropRepeats = createDropRepeats;
/**
 * `dropRepeats` function that uses `simpleStream`.
 */
exports.dropRepeats = (0, exports.createDropRepeats)();
